import {createElement} from "react";
import {createRoot} from "react-dom/client";

import {MonthlyRecordingApp} from "@/features/monthlyrecording/app/MonthlyRecordingApp";
import type {Config} from "@/features/monthlyrecording/types/types";

export class MonthlyRecordingPage {
	constructor(mountTargetId: string, config: Config) {
		const container = document.getElementById(mountTargetId);
		if (!container) {
			throw new Error(`React mount target #${mountTargetId} was not found`);
		}
		createRoot(container).render(createElement(MonthlyRecordingApp, {config}));
	}
}
